// which data type is best for what we want to do?
// array of objects**
// dictionary**
// dictionary looks good because I can call the results using
// dot notation. Also looks simpler and can add easier.

// can reference the dots by turning the reults into the
// relevant letters
// make another dictionary that references the other with numbers
// does not work. eg resLink.0

// filtering the id would work on the array of object but we
// don't need to do that.

// if we use the array we can filter through the results and
// pick out the single result we want based on the output

// can even put the relevant products in here somehow??
// maybe a second data store
// ie link to it from the first one

// only working with 2 sets of 3 answers, 3 would be too many
// 9 is manageable

// Only three results in here, description based on last question

const results = [
  {
    id: 1,
    result:
      "Wavy hair usually easier to maintain. It is quite resilient so can take more washing and conditioning. This means it doesn’t go long enough between washes to get too dry or greasy. Wavy hair is relatively light in weight and less dense so responds well to light-weight products. You should avoid rough towel drying to avoid frizz and gently diffuse if you can. Here are some products you can check out based on your selection…"
  },
  {
    id: 2,
    result:
      "Curly hair usually takes effort to keep moisturised. Your hair should be washed and conditioned every few days. Some people can get away with not using sulphate-free products keep moisture but it is recommended if you really struggle. You should use a generous amount of leave in conditioner and use a diffuser to dry. You can use natural oils to detangle with a wide tooth comb to avoid damage. Here are some products you can check out based on your selection…"
  },
  {
    id: 3,
    result:
      "Coily or Kinky hair can be the most demanding of the hair types. It is rewarding when you finally figure it out. Your hair goes longer between washes, about a week at a time. Moisture is very important and should be washed and conditioned properly. Coily hair tangles easily so detangle in stages. First use fingers then a wide tooth comb. Longer periods between washing and product build up on the scalp can lead to irritation, dry or greasy. Make sure you wrap your hair at night to protect it. "
  }
];

// console.log(results);
// console.log(results[1 - 1].result);

// const [one, two] = results;
// console.log(one, two);

// const result = {
//   a: "You need help",
//   b: "You need more help",
//   c: "You need even more help"
// };

// console.log(result.a, result.b);
// console.log(result.a);

export default results;
